import { useCallback, useMemo } from "react";
import { generatePath, useNavigate } from "react-router-dom";

import SectionHeadingTabs from "~/components/headings/SectionHeadingTabbar";
import { PROJECT_DETAILS_PATH_WITH_TAB_ID } from "~/constants/appRoutes.ts";
import { ProjectDetailsTabName } from "~/modules/project/types/projectViewTypes.ts";
import type { SectionHeadingTab } from "~/types/tabsTypes.ts";

type Props = {
	className?: string
	activeTabId: ProjectDetailsTabName | string;
	projectId: string;
};

const BillingTabSubNavigation = ({ activeTabId, projectId }: Props) => {
	const navigate = useNavigate();
	const tabs = useMemo(() => {
		const tabs: SectionHeadingTab[] = [
			{
				name: "Abrechnungsdetails",
				value: ProjectDetailsTabName.BillingSettings,
				active: activeTabId === ProjectDetailsTabName.BillingSettings,
			},
			{
				name: "Rechnungen",
				value: ProjectDetailsTabName.Invoices,
				active: activeTabId === ProjectDetailsTabName.Invoices,
			},
		];
		return tabs;
	}, [activeTabId]);

	if (![ProjectDetailsTabName.Invoices, ProjectDetailsTabName.BillingSettings].includes(activeTabId as ProjectDetailsTabName)) {
		return null;
	}

	const handleTabClick = useCallback((value: string) => {
		navigate(generatePath(PROJECT_DETAILS_PATH_WITH_TAB_ID, { projectId: projectId, tabId: value }));
	}, [navigate, projectId]);

	return <SectionHeadingTabs tabs={tabs}
							   onTabClick={handleTabClick} />;
};

export default BillingTabSubNavigation;